import { useForm } from 'antd/lib/form/Form'
import { Button, Form, Row, Space, Steps } from 'antd'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { Step, SteppedModalProps } from './types'
import FormlessModal from '../FormlessModal'
import { Store } from 'antd/lib/form/interface'

const SteppedModal: React.FC<SteppedModalProps> = ({
  steps,
  visible,
  ok,
  cleanUp,
  onClose,
  initialFormValues,
}) => {
  const [form] = useForm()
  useEffect(() => {
    if (initialFormValues) form.setFieldsValue(initialFormValues)
  }, [initialFormValues, form])

  const [store, setStore] = useState<Store>({})
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState(0)
  const max = steps.length - 1

  const getCurrent = async () => {
    let current
    try {
      current = await form.validateFields()
    } catch (_) {
      return undefined
    }
    return current
  }
  const validate = async (to: 'next' | 'prev') => {
    const current = await getCurrent()
    if (!current) return
    setStore((prev) => ({ ...prev, ...current }))
    setStep((prev) => (to === 'next' ? prev + 1 : prev - 1))
  }
  const children = useCallback(
    ({ component }: Step) => {
      if (typeof component === 'function') return component(store)
      return component
    },
    [store]
  )

  return (
    <FormlessModal
      ok={false}
      afterClose={() => {
        setLoading(false)
        form.resetFields()
        setStore({})
        setStep(0)
      }}
      /**
       * still have to set the cancel callback for the close icon in the top
       */
      cancel={{ fn: () => onClose() }}
      visible={visible}
      title={
        <Steps current={step} style={{ width: '95%' }}>
          {steps.map(({ title }, i) => (
            <Steps.Step key={`stepped-modal-${title}-${i}`} title={title} />
          ))}
        </Steps>
      }
      footer={
        <Row justify="end">
          <Space size="large">
            <Button
              onClick={() => {
                cleanUp?.(store)
                onClose()
              }}
            >
              Cancel
            </Button>
            <Button onClick={() => validate('prev')} disabled={step === 0}>
              Previous
            </Button>
            {step < max && (
              <Button onClick={() => validate('next')} type="primary">
                Next
              </Button>
            )}
            {step === max && (
              <Button
                onClick={() => form.submit()}
                type="primary"
                loading={loading}
              >
                {typeof ok.title === 'function'
                  ? ok.title(store)
                  : ok.title ?? 'Ok'}
              </Button>
            )}
          </Space>
        </Row>
      }
    >
      <Form
        initialValues={initialFormValues}
        form={form}
        onFinish={async () => {
          setLoading(true)
          const current = await getCurrent()
          if (!current) return
          await ok.fn({ ...store, ...current })
          onClose()
        }}
      >
        {steps.map(($tep, i) =>
          step !== i ? null : <Fragment key={i}>{children($tep)}</Fragment>
        )}
      </Form>
    </FormlessModal>
  )
}

export default SteppedModal
